exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "gz-time-range .end-time .label,gz-time-range .start-time .label{color:rgba(0,0,0,.54);font-size:13px}gz-time-range .end-time md-input-container,gz-time-range .start-time md-input-container{margin:0;padding:0}gz-time-range .end-time{padding-left:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!../~/@printos/gazelle/src/components/time-range/time-range.scss
// module id = 120
// module chunks = 0